import { lazy } from 'react';

const Wallet = lazy(() => import('./Wallet'));

export default Wallet;
